import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5em 0;
  cursor: pointer;
`;

export const Label = styled.label`
  margin-left: 0.5em;
  cursor: pointer;
`;
